import './App.css';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/800.css';
import '@fontsource/poppins/900.css';
import {Grid} from "@mui/system";
import Pagina from "./Pagina/Pagina";
import {createContext, useEffect} from "react";
import {collection, orderBy, query, where} from "firebase/firestore";
import {fire} from "./fire";
import {obtenerFechaAct} from "./Servicios/BD/Actualizadores/obtenerFechaAct";
import {useObtenerDataActualizada} from "./Modulo_Optimizacion_Data/Hooks/useObtenerDataActualizada";

export const contexApp = createContext()

function App() {
    const {data: anuncios, actualizarDataLocal: actAnuncios} = useObtenerDataActualizada({
        clave: 'anuncios',
    })
    const {data: banners, actualizarDataLocal: actBanners} = useObtenerDataActualizada({
        clave: 'banners',
    })
    const {data: tipos, actualizarDataLocal: actTipos} = useObtenerDataActualizada({
        clave: 'tipos',
    })
    const {data: categorias, actualizarDataLocal: actCategorias} = useObtenerDataActualizada({
        clave: 'categorias',
    })
    const {data: fotos, actualizarDataLocal: actFotos} = useObtenerDataActualizada({
        clave: 'fotos',
    })
    const {data: rutas, actualizarDataLocal: actRutas} = useObtenerDataActualizada({
        clave: 'rutas',
    })
    const {data: politicas, actualizarDataLocal: actPoliticas} = useObtenerDataActualizada({
        clave: 'politicas',
    })




    const valoresProvider = {
        anuncios,
        banners,
        tipos,
        categorias,
        fotos,
        rutas,
        politicas,
    }

    const {Provider} = contexApp;

    useEffect(() => {

        //se verifica si esta o no actualizado

        let w = [where('estado', '==', 'Publicado')]
        obtenerFechaAct('anuncios').then((dox) => {
            actAnuncios({fecha: dox, wheres: w}).then()
        })

        obtenerFechaAct('banners').then((dox) => {
            actBanners({fecha: dox, wheres: w}).then()
        })

        obtenerFechaAct('tipos').then((dox) => {
            actTipos({fecha: dox, wheres: []}).then()
        })

        obtenerFechaAct('categorias').then((dox) => {
            actCategorias({fecha: dox, wheres: []}).then()
        })

        obtenerFechaAct('fotos').then((dox) => {
            actFotos({fecha: dox, wheres: []}).then()
        })

        obtenerFechaAct('rutas').then((dox) => {
            actRutas({fecha: dox, wheres: []}).then()
        })

        obtenerFechaAct('politicas').then((dox) => {
            actPoliticas({fecha: dox, wheres: []}).then()
        })


    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Provider value={valoresProvider}>
                <Pagina/>
            </Provider>

        </Grid>
    );
}

export default App;
